export default __webpack_public_path__ + "static/media/05-problem-statement.b7c33eb9.svg";